import clsx from "clsx";
import React from "react";
import { useMedia } from "../../hooks";
import { formatAsCurrency } from "../../utils/text";
import classes from "./Item.module.scss";

const StockLabel = ({ quantity, hover = true }) => (
	<span className={clsx('label', {
		[classes.stockLabel]: hover,
		'label-success': quantity > 50,
		'label-warning': quantity < 50 && quantity > 0,
		'label-danger': quantity <= 0
	})}>
		{
			quantity > 50
				? `50+ ${hover ? "STOCK" : "AVAILABLE"}`
				: quantity > 0
					? `${quantity} ${hover ? "STOCK" : "AVAILABLE"}`
					: hover ? "OUT OF STOCK" : "UNAVAILABLE"
		}
	</span>
)

const Item = ({ item }) => {

	const isMobile = useMedia('(max-width: 991.8px)')

	if (isMobile) return (
		<a title={item.get('title')} href={item.get('product_url')} onClick={item.onClick}>
			<div className={clsx(classes.listItem, classes.root)}>
				<div className={classes.imageWrapper}>
					<img alt={item.get('title')} src={item.get('image_url')} />
				</div>
				<div>
					<p>
						{item.get('title')}
					</p>
					<StockLabel quantity={item.get('quantity')} hover={false} />
				</div>
				<span>
					{formatAsCurrency(Number(item.get("price").first()))}
				</span>
			</div>
		</a>
	)

	return (
		<div className={classes.root}>
			<StockLabel quantity={item.get('quantity')} />
			<a title={item.get("title")} href={item.get("product_url")} onClick={item.onClick}>
				<div className={classes.imageContainer}>
					<img alt={item.get("title")} className={classes.image} src={item.get('image_url')} />
				</div>
			</a>
			<a title={item.get("title")} href={item.get("product_url")} onClick={item.onClick}>
				<div className="text-center">
					<p className={classes.title}>
						{item.get("title")}
					</p>
					<p>{formatAsCurrency(Number(item.get("price").first()))}</p>
				</div>
			</a>
		</div>
	);
};

export default Item;
